import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getKioskTicketTemplatesState = (state: GlobalState) => state[KEY];

const selectKioskTicketTemplates = createSelector(
  getKioskTicketTemplatesState,
  (ticketTemplates) => ticketTemplates.kioskTicketTemplates
);

const selectAction = createSelector(getKioskTicketTemplatesState, (ticketTemplates) => ticketTemplates.action);

export const selectors = {
  selectKioskTicketTemplates,
  selectAction
};
